/**
 * @generated SignedSource<<d0aa760c0a1f3190e9bb138c313ea2d4>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SortPeriodsModal_scheduleTemplatePeriodConnection",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "ScheduleTemplatePeriodEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "ScheduleTemplatePeriod",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "id",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "order",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "ScheduleTemplatePeriodConnection",
    "abstractKey": null
};
node.hash = "332b8b36f8cb553c89d3828fe3e8eb9c";
export default node;
